import { createContext } from 'react';

export const HousesContext = createContext();
export const HousesFilterContext = createContext();
export const SelectedItemsContext = createContext();
export const HandleItemChangeContext = createContext();
export const HandleSelectAllChangeContext = createContext();
export const HandleSelectAllHousesContext = createContext();
